import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../api/api';
import StatusMessage from '../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider, ListItemGraphic} from 'rmwc/List';

class PaginationComponent extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		data: {
    			totalItems: '',
    			itemsPerPage: ''
    		},
    		initData: {
    			pagesDropDown: [],
    			selectedPage: 1
    		}
    	}
    }

    handleItemsFetch = (value) => {
    	this.props.onHandleItemsFetch(value)
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
    	let initData = Object.assign({}, this.state.initData)
    	data.totalItems = this.props.totalItems
    	data.itemsPerPage = this.props.itemsPerPage
    	let totalPages = (parseInt(this.props.totalItems) / parseInt(this.props.itemsPerPage)) + 1
    	for (var i = 1; i <= totalPages; i++) {
            let a = i
            initData.pagesDropDown.push(a)
        }
    	this.setState({data: data, initData: initData})
    }

    handlePageChange = (event) => {
        let initData = Object.assign({}, this.state.initData)
        initData.selectedPage = event.target.value
        let particularPage = parseInt(event.target.value)
        this.handleItemsFetch(particularPage)
        this.setState({initData: initData})
    }

    handleNext = (e) => {
    	let initData = Object.assign({}, this.state.initData)
		let nextPage = parseInt(this.state.initData.selectedPage) + 1

		initData.selectedPage = nextPage
    	this.handleItemsFetch(nextPage)
    	this.setState({initData: initData})
    }

    handlePrevious = (e) => {
    	let initData = Object.assign({}, this.state.initData)
    	let previousPage = parseInt(this.state.initData.selectedPage) - 1

    	initData.selectedPage = previousPage
    	this.handleItemsFetch(previousPage)
    	this.setState({initData: initData})
    }

    render() {
    	let handlePrevious = this.handlePrevious
    	let handleNext = this.handleNext
    	let arr = this.state.initData.pagesDropDown
    	let prevCount = parseInt(this.state.initData.selectedPage) - 1
    	let nextCount = parseInt(this.state.initData.selectedPage) + 1
    	let prevComponent, nextComponent

    	if (arr.indexOf(prevCount) > -1) {
    		prevComponent = (
    			<GridCell span = "2">
    				<Button raised style={{ width: '100%' }} onClick = {((e) => handlePrevious(e))}>Previous</Button>
    			</GridCell>
    		)
    	}
    	else {
    		prevComponent = (
    			<GridCell span = "2">
    				<Button raised disabled style={{ width: '100%' }} onClick = {((e) => handlePrevious(e))}>Previous</Button>
    			</GridCell>
    		)
    	}

    	if (arr.indexOf(nextCount) > -1) {
    		nextComponent = (
    			<GridCell span = "2">
    				<Button raised style={{ width: '100%' }} onClick = {((e) => handleNext(e))}>Next</Button>
    			</GridCell>
    		)
    	}
    	else {
    		nextComponent = (
    			<GridCell span = "2">
    				<Button raised disabled style={{ width: '100%' }} onClick = {((e) => handleNext(e))}>Next</Button>
    			</GridCell>
    		)
    	}


    	return(
    		<Grid className="opportunity-list-item">
    			{prevComponent}
    			<GridCell span = "3">
    			</GridCell>
    			<GridCell span = "2">
    				<Select
                        name="level_id"
                        onChange={this.handlePageChange}
                        defaultValue={this.state.initData.selectedPage}
                        value={this.state.initData.selectedPage}
                        className="select-component"
                        placeholder="--Select Page--">
                        {this.state.initData.pagesDropDown.map(id => (
                            <option key={id} value={id} data-name={id}>
                                {id}
                            </option>
                        ))}
                    </Select>
    			</GridCell>
    			<GridCell span = "3">
    			</GridCell>
    			{nextComponent}
    		</Grid>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginationComponent);


// WEBPACK FOOTER //
// ./src/views/PaginationComponent.jsx